import{i as t}from"../../../../_virtual/isNativeFunction.js";var e;(e=t).exports=function(t){return-1!==Function.toString.call(t).indexOf("[native code]")},e.exports.__esModule=!0,e.exports.default=e.exports;
//# sourceMappingURL=isNativeFunction.js.map
